module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-469c322a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/withNavigation/modules/modules.vue
// module id = 2987
// module chunks = 1